module.exports = __webpack_public_path__ + "static/blog-a7b030f10a64e4035fc06ec34fe74470.jpg";